module.exports = __webpack_public_path__ + "static/media/sort-amount-up-alt.7d084a57.svg";